import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import LogoCollection from './LogoCollection';

import { useNavigate } from 'react-router-dom';
import { trackEvent, EVENT_CATEGORIES, EVENT_ACTIONS } from 'utils/analytics';

export default function Hero({ userRole }) {
	const navigate = useNavigate();

	const handleButtonClick = (buttonName) => {
		trackEvent(
			EVENT_CATEGORIES.USER_INTERACTION,
			EVENT_ACTIONS.BUTTON_CLICK,
			buttonName,
		);
	};

	if (userRole === 'student') {
		return (
			<Box
				id="hero"
				sx={{
					width: '100%',
					backgroundColor: '#ffffff',
				}}
			>
				<Container
					maxWidth="lg"
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',

						pt: { xs: 4, sm: 4 },
					}}
				>
					<Paper
						elevation={0}
						sx={{
							width: '100%',
							borderRadius: 2,
							overflow: 'hidden',
							backgroundColor: '#F8F4E3',
							position: 'relative',
						}}
					>
						<Stack
							spacing={2}
							useFlexGap
							sx={{
								alignItems: 'center',
								width: '100%',
								px: { xs: 3, sm: 4 },
								pt: { xs: 8, sm: 12 },
								pb: { xs: 0, sm: 0 },
							}}
						>
							<Typography
								variant="h1"
								sx={{
									fontSize: {
										xs: '1.75rem',
										sm: '3rem',
										md: '3rem',
									},
									textAlign: 'center',
									lineHeight: { xs: 1.2, sm: 1.3 },
									mb: { xs: 1, sm: 2 },
									mt: { xs: 2, sm: 0 },
									fontWeight: 500,
									maxWidth: '900px',
								}}
							>
								Etsitkö joustavaa työtä opintojen ohelle?
							</Typography>

							<Typography
								sx={{
									textAlign: 'center',
									color: 'text.secondary',
									width: {
										xs: '100%',
										sm: '100%',
										md: '80%',
									},
									fontSize: '1.125rem',
									mb: 1,
								}}
							>
								Hyödynnä taitosi ja tee merkityksellistä työtä
								joustavasti opintojesi ohella. Löydä inspiroivia
								projekteja, kartuta arvokasta kokemusta ja
								ansaitse rahaa opiskellessasi!
							</Typography>

							<Stack
								direction={{ xs: 'column', sm: 'row' }}
								spacing={1}
								useFlexGap
								sx={{
									pt: 1,
									width: { xs: '100%', sm: 'auto' },
								}}
							>
								<Button
									variant="contained"
									size="large"
									href="https://ace93.typeform.com/to/pNzHhPOd?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx#user_id=xxxxx"
									target="_blank"
									rel="noopener noreferrer"
									onClick={() =>
										handleButtonClick(
											'student_apply_button',
										)
									}
									sx={{
										minWidth: { xs: '100%', sm: 200 },
										fontSize: '1.1rem',
									}}
								>
									Hae TalentPooliin
								</Button>
							</Stack>
						</Stack>

						<Box
							component="img"
							src="/images/platform_landing/dynamisai-profiili-mockup.jpg"
							alt="Platform preview"
							sx={{
								width: '100%',
								height: {
									xs: '300px',
									sm: '600px',
									md: '800px',
								},
								objectFit: 'cover',
								display: 'block',
								mt: 4,
							}}
						/>
					</Paper>
				</Container>
				<LogoCollection />
			</Box>
		);
	}

	// Yritysnäkymä pysyy ennallaan

	return (
		<Box
			id="hero"
			sx={{
				width: '100%',
				backgroundColor: '#ffffff',
			}}
		>
			<Container
				maxWidth="lg"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',

					pt: { xs: 4, sm: 4 },

				}}
			>
				<Paper
					elevation={0}
					sx={{
						width: '100%',
						borderRadius: 2,
						overflow: 'hidden',
						backgroundColor: '#F8F4E3',
						position: 'relative',
					}}
				>
					<Stack
						spacing={2}
						useFlexGap
						sx={{
							alignItems: 'center',
							width: '100%',
							px: { xs: 3, sm: 4 },

							pt: { xs: 6, sm: 12 },

							pb: { xs: 0, sm: 0 },
						}}
					>
						<Typography
							variant="h1"
							sx={{
								fontSize: {
									xs: '1.75rem',
									sm: '3rem',
									md: '3rem',
								},
								textAlign: 'center',
								lineHeight: { xs: 1.2, sm: 1.3 },
								mb: { xs: 1, sm: 2 },
								mt: { xs: 2, sm: 0 },
								fontWeight: 500,
								maxWidth: '900px',
							}}
						>

							Delegoi vaivattomasti - enemmän aikaa johtamiseen

						</Typography>

						<Typography
							sx={{
								textAlign: 'center',
								color: 'text.secondary',
								width: { xs: '100%', sm: '100%', md: '80%' },
								fontSize: '1.125rem',
								mb: 1,
							}}
						>

							Alihankinta ei ole koskaan ollut näin helppoa. Löydä
							tulevaisuuden huipputalentti nopeasti ja
							vaivattomasti! <br /> Alkaen 40€/h

						</Typography>

						<Stack
							direction={{ xs: 'column', sm: 'row' }}
							spacing={1}
							useFlexGap
							sx={{
								pt: 1,
								width: { xs: '100%', sm: 'auto' },
							}}
						>
							<Button
								variant="contained"
								size="large"

								href="https://ace93.typeform.com/to/xcwxrM4n?utm_source=xxxxx&utm_medium=xxxxx&utm_campaign=xxxxx&utm_term=xxxxx&utm_content=xxxxx#user_id=xxxxx"
								onClick={() =>
									handleButtonClick('company_start_button')
								}

								sx={{
									minWidth: { xs: '100%', sm: 200 },
									fontSize: '1.1rem',
								}}
							>
								Aloita nyt
							</Button>
						</Stack>
					</Stack>

					<Box
						component="img"
						src="/images/platform_landing/dynamisai-profiili-mockup.jpg"
						alt="Platform preview"
						sx={{
							width: '100%',
							height: { xs: '300px', sm: '600px', md: '800px' },
							objectFit: 'cover',
							display: 'block',
							mt: 4,
						}}
					/>
				</Paper>
			</Container>
			<LogoCollection />
		</Box>
	);
}
